import React from 'react';
import {
    Card, Anchor
} from '@americanexpress/dls-react';
import { ProductHighlights } from '../ProductHighlights';
import { Fee } from '../Fee';
import { FootNotes } from '../FootNotes';

export function SideBar({ productHighlights, journeyContent }) {
    return (
        <Card>
            <div className="pad-responsive-lr">
                <div className="stack body">
                    <div className="border-dark-dashed-b">
                        <ProductHighlights highlights={productHighlights} />
                    </div>
                    <div className="border-dark-dashed-b stack pad-1-b">
                        <Fee content={journeyContent} />
                    </div>
                    <div className="border-dark-dashed-b pad-1-b">
                        <div>
                            <div>
                                {journeyContent.footnotes && journeyContent.footnotes.length !== 0 && (
                                    <FootNotes content={journeyContent} />
                                )}
                            </div>
                            <div>
                                <Anchor href="https://www.americanexpress.com/in/mitc" target="_blank">MITC</Anchor>
                            </div>
                            <div>
                                {journeyContent.offerTermsUrl && journeyContent.offerTermsUrl !== null && journeyContent.offerTermsUrl !== '' && (
                                    <Anchor href={journeyContent.offerTermsUrl} target="_blank">*Offer Terms &amp; Conditions</Anchor>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
}
export default SideBar;